module.exports = __webpack_public_path__ + "static/media/sh.c4cd6642.svg";